import React from "react";
import MuiBaseModal from "../../common/modal/MuiModal";
import { RoleSchema } from "../../../services/Schemas/Role";
import CreateRoleForm from "../../../forms/role-edit-create/CreateRoleForm";

interface ICreateRole {
  onClose: (payload: boolean) => void;
  handleReload?: () => void;
  roleInfo?: RoleSchema;
  open: boolean;
}

export default function CreateRoleModal({
  onClose,
  open,
  roleInfo,
  handleReload,
}: ICreateRole) {
  return (
    <MuiBaseModal
      open={open}
      onClose={() => onClose(false)}
      title={roleInfo ? "ویرایش نقش" : "ایجاد نقش"}
      hasCloseIcon
    >
      <CreateRoleForm
        roleInfo={roleInfo}
        onSuccess={() => {
          onClose(false);
          handleReload && handleReload();
        }}
      />
    </MuiBaseModal>
  );
}
